import React from 'react';

const Results = ({ data }) => {
    if (!data || !data.result) {
        return <p>No results available.</p>;
    }

    // Assuming the data structure based on the API response
    const { crop, disease } = data.result;

    return (
        <div>
            <h2>Detection Results</h2>

            {/* Crop suggestions */}
            {crop && crop.suggestions && crop.suggestions.length > 0 && (
                <div>
                    <h3>Crop Suggestions:</h3>
                    {crop.suggestions.map((suggestion, index) => (
                        <div key={index}>
                            <p><strong>Crop Name:</strong> {suggestion.name}</p>
                            <p><strong>Scientific Name:</strong> {suggestion.scientific_name}</p>
                            <p><strong>Probability:</strong> {suggestion.probability.toFixed(2) * 100}%</p>
                        </div>
                    ))}
                </div>
            )}

            {/* Disease suggestions */}
            {disease && disease.suggestions && disease.suggestions.length > 0 && (
                <div>
                    <h3>Disease Suggestions:</h3>
                    {disease.suggestions.map((suggestion, index) => (
                        <div key={index}>
                            <p><strong>Disease Name:</strong> {suggestion.name}</p>
                            <p><strong>Scientific Name:</strong> {suggestion.scientific_name}</p>
                            <p><strong>Probability:</strong> {suggestion.probability.toFixed(2) * 100}%</p>
                           
                        </div>
                    ))}
                </div>
            )}

            {(!crop || !crop.suggestions.length) && (!disease || !disease.suggestions.length) && (
                <p>No results available for the detected crop or disease.</p>
            )}
        </div>
    );
};

export default Results;
